import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import Component from './connection-line';
import ConnectionLineStore from './store';


const ConnectionLine = props => {
  const { startPoint, endPoint, containerWidth, minY, minStartY, minEndY } = ConnectionLineStore;

  useEffect(()=>{
    return () => {
      ConnectionLineStore.resetPoint();
    }
  }, [])

  if (!startPoint || !endPoint) return null;
  
  return (
    <div
      className="absolute left-[-57px] top-0 h-full w-100px z-1 pointer-events-none overflow-hidden"
      style={{
        width: `${ConnectionLineStore.containerWidth}px`,
        left: `-${ConnectionLineStore.containerWidth-68}px`,
      }}
    >
      <Component
        startPoint={startPoint}
        endPoint={endPoint}
        minStartY={minStartY}
        minEndY={minEndY}
        width={containerWidth}
        height={window.innerHeight}
        minY={minY}
      />
    </div>
  );
};

export default observer(ConnectionLine);
